module.exports = __webpack_public_path__ + "static/media/insurance.ed1659d5.png";